<template>
  <div class="article-list-content">
    <category :first="first" :second="second" :third="query.third" v-if="second"/>
    <div class="article-list">
      <data-list  :data-list="dataList" :loading="loading"/>
      <pagination v-if="!loading && dataList.length > 0 && pages > 1" :total="total" @pagination="changePage"
                  layout="total, prev, pager,next"
                  :page-num="query.pageNum"
                  :page-size="query.pageSize"/>
    </div>
  </div>
</template>

<script>

import DataList from "@/views/article/components/data-list.vue";
import Category from "@/views/article/components/category.vue";
import * as articleApi from "@/api/article";
import Pagination from "@/components/Pagination/index.vue";

export default {
  name: "article-list",
  components: {Pagination, Category, DataList},
  props: {
    first: {
      type: String,
    },
    second: {
      type: String,
    },
  },
  watch: {
    '$route'(to, from) {
      this.query = this.$options.data().query
      let params = to.params;
      this.query.first = params.first;
      if (params.second) {
        this.query.second = params.second;
      }
      let third = this.$route.query.category;
      if (third) {
        this.query.third = third;
      }
      let pageNum = this.$route.query.pageNum;
      if (pageNum) {
        this.query.pageNum = parseInt(pageNum);
      }
      this.list();
    }
  },
  data() {
    return {
      value: true,
      loading: true,
      dataList: [],
      pages: 0,
      total: 0,
      query: {
        pageNum: 1,
        pageSize: 20,
        orderBy: 'updateTime',
        sort: 'desc',
      },
    }
  },
  mounted() {
    this.query.first = this.first;
    this.query.second = this.second;
    let third = this.$route.query.category;
    if (third) {
      this.query.third = third;
    }
    let pageNum = this.$route.query.pageNum;
    if (pageNum) {
      this.query.pageNum = parseInt(pageNum);
    }
    this.list();
  },
  methods: {
    list() {
      if (!this.query.pageNum) {
        this.query.pageNum = 1;
      }
      this.loading = true;
      articleApi.listArticle(this.query).then(res => {
        if (res.code === 200) {
          this.dataList = res.data.list;
          this.pages = res.data.pages;
          this.total = res.data.total;
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    location() {
      let href = "";
      if (this.first) {
        href += "/" + this.first;
      }
      if (this.second) {
        href += "/" + this.second;
      }
      if (this.query.third) {
        href += "?category=" + this.query.third;
        href += "&pageNum=" + this.query.pageNum
      } else {
        href += "?pageNum=" + this.query.pageNum
      }
      this.$router.push(href);
    },
    changePage(current) {
      this.query.pageNum = Number.parseInt(current);
      this.location();
    },
  }
}
</script>

<style lang="scss">
.article-list-content{
  .article-list{
    margin-top: 20px;
    border-radius: 6px;
    border: 1px solid --color(--p-border-color);
    box-shadow: 0 8px 16px -4px rgba(44,45,48,0.047);
    overflow: hidden;

    @media (max-width: 767px) {
      border:none;
      box-shadow:none;
      border-radius:0;
    }
  }
}
</style>
